var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGmx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 608,
    height: 472,
    viewBox: "0 0 608 472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.536,
    y1: 0.026,
    x2: 0.011,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03d1cf",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e09f8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-GMX_LOGO_ONLY"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 608,
    height: 472
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GMX_LOGO_ONLY",
    "data-name": "GMX_LOGO ONLY",
    clipPath: "url(#clip-GMX_LOGO_ONLY)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO_GMX",
    "data-name": "LOGO GMX",
    transform: "translate(1.317 -16.974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BASE",
    width: 608,
    height: 472,
    transform: "translate(-1.317 16.974)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M1070.463,1104.6,798.486,696,525.667,1104.6H905.756L798.486,948.649l-53.212,81.022H688.683l109.8-162.915L957.28,1104.6Z",
    transform: "translate(-494.667 -647.027)",
    fill: "url(#linear-gradient)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmx);
export default __webpack_public_path__ + "static/media/gmx.6fc1660036011543336a652224237c07.svg";
export { ForwardRef as ReactComponent };